module.exports = __webpack_public_path__ + "img/Sx@2x.e7274b3d.png";